import React, { ReactNode, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import NavBar from '../NavBar';
import IconButton from '../IconButton';
import Dropdown from '../Dropdown';
import HeaderPatientInfo from '../HeaderPatientInfo';
import { PatientInfoVisibility } from '../../types/PatientInfoVisibility';
import { Icons } from '@ohif/ui-next';
import TopNavBar from '../TopNavBar';
import Icon from '../Icon';
function TopBar({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  WhiteLabeling,
  showPatientInfo = PatientInfoVisibility.VISIBLE_COLLAPSED,
  servicesManager,
  Secondary,
  appConfig,
  setShowSideMenu,
  ...props
}: withAppTypes): ReactNode {
  const { t } = useTranslation('Header');

  // TODO: this should be passed in as a prop instead and the react-router-dom
  // dependency should be dropped
  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };

  // const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setScreenWidth(window.innerWidth);
  //   };

  //   // Add event listener
  //   window.addEventListener('resize', handleResize);

  //   // Cleanup on component unmount
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);

  return (
    <TopNavBar
      isSticky={isSticky}
      {...props}
    >
      <div className="relative h-[48px] items-center p-2">
        <div className="absolute left-0 top-1/2 flex -translate-y-1/2 items-center">
          <div
            className={classNames(
              'mr-3 inline-flex items-center',
              isReturnEnabled && 'cursor-pointer'
            )}
            onClick={onClickReturn}
            data-cy="return-to-work-list"
          >
            {isReturnEnabled && <Icons.ChevronClosed className="text-primary-active w-8" />}
            {/* <div className="ml-1">
              {WhiteLabeling?.createLogoComponentFn?.(React, props) || <Icons.OHIFLogo />}
            </div> */}
          </div>
          {window.innerWidth > 768 && (
            <button
              className="btnCollapse btnHamburger"
              id="sidebarCollapse"
              type="button"
              onClick={() => {
                setShowSideMenu(prev => !prev);
                const sidebar = document.getElementsByTagName('body')[0];
                sidebar.classList.toggle('sidebar-hidden');
              }}
            >
              <Icon name="sidebar-menu" />
            </button>
          )}
        </div>
        <div className="absolute top-1/2 left-[250px] h-8 -translate-y-1/2">{Secondary}</div>
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
          <div className="flex items-center justify-center space-x-2">{children}</div>
        </div>
        <div className="absolute right-0 top-1/2 flex -translate-y-1/2 select-none items-center">
          {showPatientInfo !== PatientInfoVisibility.DISABLED && (
            <HeaderPatientInfo
              servicesManager={servicesManager}
              appConfig={appConfig}
            />
          )}
          <div className="border-primary-dark mx-1.5 h-[25px] border-r"></div>
          <div className="flex-shrink-0">
            <Dropdown
              id="options"
              showDropdownIcon={false}
              list={menuOptions}
              alignment="right"
            >
              <IconButton
                id={'options-settings-icon'}
                variant="text"
                color="inherit"
                size="initial"
                className="text-primary-active hover:bg-primary-dark h-full w-full"
              >
                <Icons.ByName name="icon-settings" />
              </IconButton>
            </Dropdown>
          </div>
          {window.innerWidth < 768 && (
            <button
              className="btnCollapse btnHamburger"
              id="sidebarCollapse"
              type="button"
              onClick={() => {
                setShowSideMenu(prev => !prev);
                const sidebar = document.getElementsByTagName('body')[0];
                sidebar.classList.toggle('sidebar-hidden');
              }}
              style={{ marginLeft: '1rem' }}
            >
              <Icon name="sidebar-menu" />
            </button>
          )}
        </div>
      </div>
    </TopNavBar>
  );
}

TopBar.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.object,
  showPatientInfo: PropTypes.string,
  servicesManager: PropTypes.object,
};

export default TopBar;
